const NBSP = '\u00A0';
const BLOCKS = 'p, li, h1, h2, h3, h4, h5, h6, figcaption, blockquote, td, th';

const textNodes = (el) => {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
};

// Glue the last two words of a block together so a lone word never ends a paragraph.
const glueLastWords = (el) => {
  const nodes = textNodes(el).filter((n) => n.nodeValue.trim().length > 0);
  if (!nodes.length) return;
  const last = nodes[nodes.length - 1];
  const text = last.nodeValue.replace(/\s+$/, '');
  const m = text.match(/^(.*\S)\s+(\S+)$/s);
  if (m) {
    last.nodeValue = `${m[1]}${NBSP}${m[2]}` + last.nodeValue.slice(text.length);
    return;
  }
  if (/^\s/.test(last.nodeValue)) {
    last.nodeValue = last.nodeValue.replace(/^\s+/, NBSP);
    return;
  }
  const prev = nodes[nodes.length - 2];
  if (prev && /\s$/.test(prev.nodeValue)) {
    prev.nodeValue = prev.nodeValue.replace(/\s+$/, NBSP);
  }
};

export const preventRunts = (html) => {
  if (!html || typeof window === 'undefined') return html;
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const root = doc.body.firstChild;
  root.querySelectorAll(BLOCKS).forEach((el) => {
    if (el.querySelector(BLOCKS)) return;
    glueLastWords(el);
  });
  return root.innerHTML;
};
